import { useQuery } from 'react-query';
import { Tenant, HTTPError } from 'types';
import { getQueryAsync } from 'api/api-client';
import { tenantInfo } from 'common/constants';

const getTenants = async () => {
    return getQueryAsync(`/Tenants`).then(({ tenants }: { tenants: string[] }) =>
        tenants.map(tenant => ({ id: tenant, ...tenantInfo[tenant] }))
    );
};

export default function useTenants() {
    return useQuery<Tenant[], HTTPError>(['Tenants'], getTenants, {
        refetchOnWindowFocus: false
    });
}
